module.exports = __webpack_public_path__ + "static/logo-transparent-2026-ea425994805391c488b666b1262dcfbb.png";